// Công tắc trợ năng (UI_SPEC §21). Scope 'device': tùy chọn của máy, không đồng bộ.
import { signal, computed } from '@preact/signals';
import { registerSlice } from '../registry';
import { isPlainObject } from '@save/types';

export interface Settings {
  reduceMotion: boolean;
  horrorFx: boolean;
  screenShake: boolean;
  reduceFlash: boolean;
  textScale: 1 | 1.1 | 1.2;
  highContrast: boolean;
  cbTelegraph: boolean;
  haptics: boolean;
  volMaster: number;
  volSfx: number;
  volMusic: number;
}

export type BoolSetting = { [K in keyof Settings]: Settings[K] extends boolean ? K : never }[keyof Settings];

function prefersReducedMotion(): boolean {
  return typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches;
}

export function defaultSettings(): Settings {
  return {
    reduceMotion: prefersReducedMotion(),
    horrorFx: true,
    screenShake: true,
    reduceFlash: false,
    textScale: 1,
    highContrast: false,
    cbTelegraph: false,
    haptics: typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function',
    volMaster: 0.8,
    volSfx: 0.8,
    volMusic: 0.8,
  };
}

const _settings = signal<Settings>(defaultSettings());
export const settings = computed(() => _settings.value);

export function toggleSetting(k: BoolSetting): void {
  _settings.value = { ..._settings.value, [k]: !_settings.value[k] };
}

registerSlice<Settings>({
  key: 'settings',
  scope: 'device',
  serialize: () => _settings.value,
  hydrate: (d) => {
    const s = defaultSettings();
    if (isPlainObject(d)) {
      for (const k of Object.keys(s) as (keyof Settings)[]) {
        const v = d[k];
        if (typeof v === typeof s[k]) (s as unknown as Record<string, unknown>)[k] = v;
      }
      if (![1, 1.1, 1.2].includes(s.textScale)) s.textScale = 1;
    }
    _settings.value = s;
  },
});
